import React, { useState } from "react";
import "./training-card.scss";
import { TrainingCardView } from "./training-card-view";
export const TrainingCardControler = (props) => {
	const [isHover, setIsHover] = useState(false);
	const HandleHoverState = () => {
		setIsHover(!isHover);
	};
	return <TrainingCardView isHover={isHover} HandleHoverState={HandleHoverState} {...props} />;
};
